<!-- 示例页面 -->
<template>
  <div class="page">
    <div class="p16 flex-row">
      <div>
        <span class="cur" @click="back"><i class="el-icon-arrow-left"></i>返回</span>
        <el-divider direction="vertical"  class="color999"></el-divider>
        <span class="color999 cur" @click="back">开单打卡&nbsp;/&nbsp;</span>
      </div>
      <div>请假管理</div>
    </div>
    <div class="page-head">
      <div class="mains-content">
        <div class="member-content-box br10">
          <div class="member-header space-between">
            <div class="flex-row">
              <el-select v-model="query.auditStatus" placeholder="审核状态" filterable @change="selectChange">
                <el-option label="全部状态" value></el-option>
                <el-option label="待审核" value="wait"></el-option>
                <el-option label="处理中" value="processing"></el-option>
                <el-option label="通过" value="pass"></el-option>
                <el-option label="拒绝" value="refuse"></el-option>
                <el-option label="取消" value="cancel"></el-option>
              </el-select>
            </div>
            <el-button type="primary" @click="addList" v-perm="{key:'attendancePunch', value: 'attendancePunch:leave'}">请假申请</el-button>
          </div>
          <div class="plr16">
            <el-table :data="list" :max-height="height - 265" header-cell-class-name="table_header_bgcolor">
              <el-table-column prop="staffName" label="店员姓名"></el-table-column>
              <el-table-column prop="auditStatusCn" label="审核状态" width="auto"></el-table-column>
              <el-table-column prop="leaveCateName" width="auto" label="请假类型"></el-table-column>
              <el-table-column prop="beginTime" label="开始时间" width="auto">
                <template slot-scope="scope">{{ formatDay(scope.row.beginTime) }}</template>
              </el-table-column>
              <el-table-column prop="endTime" label="结束时间" width="auto">
                <template slot-scope="scope">{{ formatDay(scope.row.endTime) }}</template>
              </el-table-column>
              <el-table-column prop="oxCtime" label="创建时间" width="170px">
                <template slot-scope="scope">{{ formatDate(scope.row.oxCtime) }}</template>
              </el-table-column>
              <el-table-column prop="amt" label="操作" align="center" fixed="right" width="100">
                <template slot-scope="scope">
                    <el-link type="primary" @click="leaveRequest(scope.row)">详情</el-link>
                    <el-link type="primary" class="ml5" v-if="scope.row.isCanCancel" @click="cancelVacation(scope.row)">销假</el-link>
                    
                </template>
              </el-table-column>
            </el-table>
            <paging :currentPage="query.start" :totalCount="totalCount" @doPageQuery="doDataQuery"></paging>
          </div>
        </div>
      </div>
    </div>
    <edit-set ref="editSetForm" @change="handleChange"></edit-set>
    <add-set ref="addSetForm" @change="handleChange"></add-set>
    <cancel-vacation ref="cancelForm" @change="handleChange"></cancel-vacation>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editSet from "./edit";
import addSet from "./add";
import cancelVacation from "./cancelVacation.vue"
export default {
  data() {
    return {
      url: this.$url.companyLeave.list,
      query: {
        auditStatus: "",
        start: 0,
        size: 20
      },
      height: this.$store.getters.MainHeight,
      list: []
    };
  },
  mixins: [minxin],
  components: { editSet, cancelVacation, addSet},
  computed: {},

  created() {
    this.totalCounts();
    
  },
  mounted () {
    this.$nextTick(() => {
      if (sessionStorage.getItem("attendanceParmas")) {
        this.$refs["addSetForm"].$emit("set", true);
      }
    })
  },
  methods: {
    back() {
      this.$router.push("/dataList/attendancePunch");
    },
    leaveRequest (row) {
      this.$refs["editSetForm"].$emit("set", row);
    },
    addList () {
      this.$refs["addSetForm"].$emit("set", true);
    },
    handleChange(bool) {
      if (bool) {
        this.totalCounts();
      }
    },
    selectChange() {
      this.query.start = 0;
      this.totalCounts();
    },
    totalCounts () {
      this.$api.post(this.$url.companyLeave.count, this.query).then(res => {
        this.getData();
        this.totalCount = res;
      }).catch(error => {});
    },
    cancelVacation (row) {
      this.$refs["cancelForm"].$emit("set", row);
    }
  }
};
</script>
<style scoped lang="less">
@import "../../../assets/css/edit.less";
.page-head {
  height: 100%;
}
.mains-content {
  height: calc(100% - 72px);
  .member-content-box {
    background: #fff;
  }
  .member-header {
    
    padding: 16px;
    display: flex;
  }
}
</style>

